import { THYSSENKRUPP_LOGO, ONLINE_METALS_LOGO } from 'constants/all';

const CONFIGURE_STOCK = 'CONFIGURE_STOCK';
const MATERIAL_SELECT = 'MATERIAL_SELECT';
const VENDOR_QUOTE = 'VENDOR_QUOTE';

export const PANEL_STATES = {
  CONFIGURE_STOCK,
  MATERIAL_SELECT,
  VENDOR_QUOTE,
} as const;

export const VENDOR_QUOTE_REQUEST_STATUSES = {
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  IN_PROGRESS: 'IN_PROGRESS',
};

export const VENDOR_QUOTE_STATUSES = {
  BID: 'BID',
  REQUESTED: 'REQUESTED',
  VENDOR_MANUAL_INPUT_REQUIRED: 'VENDOR_MANUAL_INPUT_REQUIRED',
  VENDOR_REVIEW_REQUIRED: 'VENDOR_REVIEW_REQUIRED',
};

export const VENDOR_QUOTE_SOURCES = {
  BAQ_PAGE: 'BAQ_PAGE',
  PURCHASING_PAGE: 'PURCHASING_PAGE',
};

export const ONLINE_METALS = 'online_metals';
export const THYSSENKRUPP = 'thyssenkrupp';
const ONLINE_METALS_RESULTS_KEY = 'onlineMetals';
const THYSSENKRUPP_RESULTS_KEY = 'thyssenkrupp';

export const VENDOR_RESULTS_KEY_MAP = {
  [ONLINE_METALS]: ONLINE_METALS_RESULTS_KEY,
  [THYSSENKRUPP]: THYSSENKRUPP_RESULTS_KEY,
};

export const VENDOR_LOGO_MAP = {
  [ONLINE_METALS]: ONLINE_METALS_LOGO,
  [THYSSENKRUPP]: THYSSENKRUPP_LOGO,
};
